var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSender2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88864 14.6667C6.90264 14.6667 6.91597 14.666 6.9293 14.6654C7.23064 14.6474 7.48197 14.4287 7.54197 14.1327L8.5673 9.08802C8.62064 8.82536 8.8253 8.62069 9.08797 8.56736L14.1326 7.54136C14.4286 7.48202 14.6473 7.23069 14.6653 6.92936C14.6833 6.62736 14.4973 6.35136 14.2106 6.25669L3.54397 2.70136C3.30464 2.62002 3.04063 2.68269 2.86197 2.86202C2.6833 3.04069 2.6213 3.30469 2.70063 3.54402L6.25663 14.2107C6.3473 14.4847 6.6033 14.6667 6.88864 14.6667Z",
    fill: "#333333"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 13,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88864 14.6667C6.90264 14.6667 6.91597 14.666 6.9293 14.6654C7.23064 14.6474 7.48197 14.4287 7.54197 14.1327L8.5673 9.08802C8.62064 8.82536 8.8253 8.62069 9.08797 8.56736L14.1326 7.54136C14.4286 7.48202 14.6473 7.23069 14.6653 6.92936C14.6833 6.62736 14.4973 6.35136 14.2106 6.25669L3.54397 2.70136C3.30464 2.62002 3.04063 2.68269 2.86197 2.86202C2.6833 3.04069 2.6213 3.30469 2.70063 3.54402L6.25663 14.2107C6.3473 14.4847 6.6033 14.6667 6.88864 14.6667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "matrix(-1 0 0 1 16 0)",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSender2);
export default __webpack_public_path__ + "static/media/sender2.73d0b886a65ff6b2022a85f50b4ad3f2.svg";
export { ForwardRef as ReactComponent };